import Animate from './Animate';
import { configBezier, configSpring } from './easing';
import { translateStyle } from './util';
import AnimateGroup from './AnimateGroup';
export { configSpring, configBezier, AnimateGroup, translateStyle };
export default Animate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-smooth/es6/index.js
// module id = 217
// module chunks = 1